export const defaultApikey = 'BurgerPosDeviceAPIKey';
export const defaultAAR = 'https://mx51.aar.mock.link';
export const defaultPosName = 'mx51';
export const defaultLocalIP = '192.168.1.10';
export const receiptFetchingMessage = 'Settle Initiated. Will be updated with Progress.';
